// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import type { OfflineToken } from '../model/OfflineToken.model';
import Loader from '../../elements/Loader';
import LoadFailed from '../../elements/LoadFailed';
import ErrorCapsule from '../../core/exceptions/ErrorCapsule';
import { useDialog } from '../../elements/Dialog';
import OfflineTabsView from './OfflineTabsView';
import CanEdit from '../../elements/CanEdit';

export type OfflineTokensListPageViewProps = {
  tokens: null | Array<OfflineToken> | ErrorCapsule,
  onRevokeToken: (token: string) => void,
  onDeleteToken: (token: string) => void,
}

export default function OfflineTokensListPageView({ tokens, onRevokeToken, onDeleteToken }: OfflineTokensListPageViewProps) {
  const { confirm } = useDialog();
  const header = (
    <>
      <h1>Офлайн-каттер</h1>
      <OfflineTabsView />
    </>
  );
  if (!tokens) return <div className="offline-tokens-list">{header}<Loader /></div>;
  if (tokens instanceof ErrorCapsule) {
    return <div className="offline-tokens-list">{header}<LoadFailed error={tokens} /></div>;
  }

  return (
    <div className="offline-tokens-list">
      {header}
      <div className="mb-1 text-right">
        <CanEdit><Link to="/offline/tokens/create/" className="btn btn-primary btn-sm">Создать токен</Link></CanEdit>
      </div>
      <table className="table">
        <thead>
          <tr>
            <th>Токен</th>
            <th>Офис</th>
            <th>Устройство</th>
            <th>Статус</th>
            <th>Создан</th>
            <th>Отозван</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {tokens.length === 0 ? (
            <tr><td colSpan={7} className="text-center text-muted">Токенов нет</td></tr>
          ) : tokens.map((token) => {
            const maskedToken = token.token
              ? token.token.substring(0, 8) + '…'
              : '—';
            const statusBadge = token.isActive
              ? <span className="badge badge-success">Активен</span>
              : <span className="badge badge-danger">Отозван</span>;
            return (
              <tr key={token.id}>
                <td><code title={token.token}>{maskedToken}</code></td>
                <td>{token.officeId ? token.officeId.substring(0, 8) + '…' : '—'}</td>
                <td>{token.deviceInfo || '—'} {token.boundDeviceId ? <code className="text-muted small">{token.boundDeviceId.substring(0, 6)}</code> : ''}</td>
                <td>{statusBadge}</td>
                <td>{new Date(token.createdAt).toLocaleDateString('ru-RU')}</td>
                <td>{token.revokedAt ? new Date(token.revokedAt).toLocaleDateString('ru-RU') : '—'}</td>
                <td className="text-right text-nowrap"><CanEdit>
                  {token.isActive ? (
                    <button type="button" className="btn btn-danger btn-sm"
                      onClick={() => confirm({
                        renderBody: () => `Отозвать токен ${maskedToken}? Устройство больше не сможет войти.`,
                        handler: () => onRevokeToken(token.token),
                      })}>
                      Отозвать
                    </button>
                  ) : (
                    <button type="button" className="btn btn-outline-danger btn-sm"
                      onClick={() => confirm({
                        renderBody: () => `Удалить отозванный токен ${maskedToken} насовсем? Запись пропадёт из списка без возможности восстановления.`,
                        handler: () => onDeleteToken(token.token),
                      })}>
                      Удалить
                    </button>
                  )}
                </CanEdit></td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
